import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  UrlTree,
  createUrlTreeFromSnapshot,
} from '@angular/router';
import { CULTURE_ROUTE_PARAM } from '@constants/app.constants';
import { Store } from '@ngrx/store';
import { selectLoggedInUser } from '@selectors/user.selector';
import { Observable, catchError, map, of } from 'rxjs';

export const loggedInUserGuard = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const culture = route.params[CULTURE_ROUTE_PARAM] as string;

  return store.select(selectLoggedInUser).pipe(
    map((loggedUser) => {
      if (!loggedUser) {
        return createUrlTreeFromSnapshot(route, [`/${culture}`]);
      }

      return true;
    }),
    catchError(() => of(false)),
  );
};
